import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const TopUpModal = ({ open, item, usersInfo, onClose, onGoToWallet }) => (
    <Modal open={open} onClose={onClose}>
        <Paper
            sx={{
                padding: 3,
                maxWidth: 400,
                width: "90%",
                margin: "auto",
                mt: "20vh",
                backgroundColor: "background.paper",
                color: "text.primary",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h6">Пополнение баланса</Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>

            {item && (
                <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Для покупки <strong>{item.custom_name || item.name || `Предмет #${item.id}`}</strong> за <strong>{item.price} ₽</strong> необходимо пополнить баланс.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Ваш текущий баланс: <strong>{usersInfo?.balance !== undefined ? `${usersInfo.balance} ₽` : "Неизвестно"}</strong>
                    </Typography>
                    <Typography variant="body2" color="error" sx={{ mb: 3 }}>
                        Недостаточно средств: <strong>{item.price - (usersInfo?.balance || 0)} ₽</strong>
                    </Typography>
                </Box>
            )}

            <Button variant="contained" color="primary" fullWidth onClick={onGoToWallet}>
                Перейти к пополнению баланса
            </Button>
            <Button variant="outlined" fullWidth sx={{ mt: 1 }} onClick={onClose}>
                Закрыть
            </Button>
        </Paper>
    </Modal>
);

export default TopUpModal;
